export class ServiceVisit {
  constructor(
    public service_visit_id: number,
    public service_id: number,
    public user_id: number,
    public user_name: string,
    public check_in_time: any,
    public check_out_time: any,
    public service_status: string,
    public note: string,
    public observer: string,
    public signature: string,
    public check_in_latitude: any,
    public check_in_longitude: any,
    public check_out_latitude: any,
    public check_out_longitude: any,
    public before_photo: string[],
    public after_photo: string[],
    public materials: any,
    public data: any,
    public audits: any
  ) {
  }
}



// WEBPACK FOOTER //
// ./src/models/service-visit.model.ts